// extracted by mini-css-extract-plugin
export default {"main":"style_main__M5PF6","chat":"style_chat__bLRFp"};